// extracted by mini-css-extract-plugin
module.exports = {"content":"nopitest_content__12luG","nopitest":"nopitest_nopitest__3VwuX","button":"nopitest_button__1-dsz"};